import React from 'react';
import {Tabs as AntTabs} from 'antd';
import './Tabs.less';
export default class Tabs extends AntTabs {
    render(){
        return <AntTabs {...this.props} className={`hms-tabs ${this.props.className || ''}`}>{this.props.children}</AntTabs>
    }
}
export class TabPane extends AntTabs.TabPane {
    render(){
        return <AntTabs.TabPane {...this.props} className={`hms-tab-pane ${this.props.className || ''}`}>{this.props.children}</AntTabs.TabPane>
    }
}
Tabs.TabPane = TabPane;